import { render, staticRenderFns } from "./AudioCustomeMobile.vue?vue&type=template&id=dec65930&scoped=true&"
import script from "./AudioCustomeMobile.vue?vue&type=script&lang=js&"
export * from "./AudioCustomeMobile.vue?vue&type=script&lang=js&"
import style0 from "./AudioCustomeMobile.vue?vue&type=style&index=0&id=dec65930&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dec65930",
  null
  
)

export default component.exports